<mat-expansion-panel *ngIf="renderType === 'fullCard'; else actionsDropdown" hideToggle="true" class="offer-expansion-panel" [expanded]="true" [disabled]="!cardExpandable">
  <mat-expansion-panel-header [collapsedHeight]="'52px'" [expandedHeight]="'52px'" class="offer-expansion-header" (click)="cardExpandable && expandToggleEvent()" data-cy="offer-panel">
    <div class="section-container" data-cy="offer-header">
      <div class="tw-flex-initial tw-self-center">
        <span>
          <mat-icon *ngIf="cardExpandable" class="expand-icon">{{ offer.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          {{ offer.name }}
        </span>
        <span class="via-api" *ngIf="offer.apiLogId">API delivered</span>
      </div>
      <div class="tw-flex-auto tw-self-center" *ngIf="offer.offerLink">
        <a target="_blank" href="{{offer.offerLink}}">
          <button
            data-cy="send-to-bp-btn"
            mat-button
            color="primary">
            Offer Link
          </button>
        </a>
      </div>
      <div class="tw-flex-1 tw-justify-self-end tw-self-center tw-ml-3">
        <div class="preview-container">
          <span class="preview-section tw-gap-2 tw-flex tw-items-center tw-justify-end" data-cy="offer-actions">
            <recommend-option-toggle
              *ngIf="!readOnly && canRecommendOptions"
              [value]="offer.isRecommended"
              (change)="recommendedToggleChange($event)"
            ></recommend-option-toggle>
            <span class="tw-font-bold">Status: </span>
            <span class="tw-font-bold status-{{offerStatus.value}} column-inline-grid tw-items-center">
              {{ offerStatus.display }}
              @if(offerStatus.value === 'declined') {
                <app-decline-info-tooltip [declineReasons]="offer.declineReasons"></app-decline-info-tooltip>
              }
            </span>
            <ng-container *ngTemplateOutlet="actionsDropdown"></ng-container>
          </span>
        </div>
      </div>
    </div>
  </mat-expansion-panel-header>

  <!-- NON-FACTORING OFFER -->
  <div class="section-container offer-values" data-cy="offer-values" *ngIf="offer.loanProductType !== 'factoring'">
    <div class="grid-section offer-section-left">
      <div class="offer-value-row">
        <div class="tw-font-bold">Amount</div>
        <div class="offer-value-column-value" *ngIf="offer.amount">{{ offer.amount | currency }}</div>
        <div class="offer-value-column-value" *ngIf="!offer.amount">—</div>
      </div>
      <div class="offer-value-row">
        <div class="tw-font-bold">Payback</div>
        <div class="offer-value-column-value" *ngIf="offer.payback">{{ offer.payback | currency }}</div>
        <div class="offer-value-column-value" *ngIf="!offer.payback">—</div>
      </div>
      <div class="offer-value-row" *ngIf="offer.apr">
        <div class="tw-font-bold">APR</div>
        <div class="offer-value-column-value">{{ offer.apr ? offer.apr + '%' : '—' }}</div>
      </div>
      <div class="offer-value-row" *ngIf="offer.factor">
        <div class="tw-font-bold">Factor</div>
        <div class="offer-value-column-value">{{ offer.factor ? offer.factor : '—' }}</div>
      </div>
      <div class="offer-value-row" *ngIf="offer.interestRate">
        <div class="tw-font-bold">Interest</div>
        <div class="offer-value-column-value">{{ offer.interestRate ? offer.interestRate + '%' : '—' }}</div>
      </div>
      <div class="offer-value-row" *ngIf="!offer.interestRate && !offer.factor && !offer.apr">
        <div class="tw-font-bold">APR/Factor/Interest</div>
        <div class="offer-value-column-value">—</div>
      </div>
      <div class="offer-value-row">
        <div class="tw-font-bold">Commission</div>
        <div class="offer-value-column-value" *ngIf="offer.commission">{{ offer.commission | currency }}</div>
        <div class="offer-value-column-value" *ngIf="!offer.commission">—</div>
      </div>
      <div class="offer-value-row">
        <div class="tw-font-bold">Points</div>
        <div class="offer-value-column-value">{{ offer.points ? offer.points : '—' }}</div>
      </div>
      <div class="offer-value-row">
        <div class="tw-font-bold"># of Payments</div>
        <div class="offer-value-column-value">{{ offer.numPayments ? offer.numPayments : '—' }}</div>
      </div>
      <div class="offer-value-row">
        <div class="tw-font-bold">Frequency</div>
        <div class="offer-value-column-value">{{ offer.paymentFrequency && paymentFrequencies[offer.paymentFrequency] ? paymentFrequencies[offer.paymentFrequency].display : '—' }}</div>
      </div>
    </div>
    <div class="grid-section offer-section-right">
      <div class="offer-value-row">
        <div class="tw-font-bold">Payment Amount</div>
        <div class="offer-value-column-value" *ngIf="offer.paymentAmount">{{ offer.paymentAmount | currency }}</div>
        <div class="offer-value-column-value" *ngIf="!offer.paymentAmount">—</div>
      </div>
      <div class="offer-value-row">
        <div class="tw-font-bold">Term</div>
        <div class="offer-value-column-value">{{ offer.term ? offer.term : '—' }} mo.</div>
      </div>
      <div class="offer-value-row">
        <div class="tw-font-bold">Origination Fee</div>
        <div class="offer-value-column-value">{{ offer.originationFee ? offer.originationFee + '%' : '—' }}</div>
      </div>
      <div class="offer-value-row">
        <div class="tw-font-bold">Position</div>
        <div class="offer-value-column-value">{{ offer.position ? offer.position : '—' }}</div>
      </div>
      <div class="offer-value-row">
        <div class="tw-font-bold">Type</div>
        <div class="offer-value-column-value">{{ offer.type | titlecase }}</div>
      </div>
      <div class="offer-value-row">
        <div class="tw-font-bold">Date Received</div>
        <div class="offer-value-column-value" *ngIf="offer.received">{{ offerRecievedFormatted | date:'shortDate' }}</div>
        <div class="offer-value-column-value" *ngIf="!offer.received">—</div>
      </div>
      <div class="offer-value-row">
        <div class="tw-font-bold">Expires</div>
        <div class="offer-value-column-value" *ngIf="offer.expiration">{{ offerExpiredFormatted | date:'shortDate' }}</div>
        <div class="offer-value-column-value" *ngIf="!offer.expiration">—</div>
      </div>
    </div>
  </div>

  <!-- FACTORING OFFER -->
  <div *ngIf="offer.loanProductType == 'factoring'">
    <div class="section-container offer-values" data-cy="offer-values">
      <div class="grid-section offer-section-left">
        <div class="offer-value-row">
          <div class="tw-font-bold">Facility Amount</div>
          <div class="offer-value-column-value" *ngIf="offer.amount">{{ offer.amount | currency }}</div>
          <div class="offer-value-column-value" *ngIf="!offer.amount">—</div>
        </div>
        <div class="offer-value-row">
          <div class="tw-font-bold">Advance Rate</div>
          <div class="offer-value-column-value" *ngIf="offer.advanceRate">{{ offer.advanceRate ? offer.advanceRate + '%' : '—' }}</div>
        </div>
        <div class="offer-value-row">
          <div class="tw-font-bold">Min Purchase Fee</div>
          <div class="offer-value-column-value">{{ offer.minPurchaseFee ? offer.minPurchaseFee + '%' : '—' }}</div>
        </div>
        <div class="offer-value-row">
          <div class="tw-font-bold">Commission</div>
          <div class="offer-value-column-value" *ngIf="offer.commission">{{ offer.commission | currency }}</div>
          <div class="offer-value-column-value" *ngIf="!offer.commission">—</div>
        </div>
        <div class="offer-value-row">
          <div class="tw-font-bold">Points</div>
          <div class="offer-value-column-value">{{ offer.points ? offer.points : '—' }}</div>
        </div>
        <div class="offer-value-row">
          <div class="tw-font-bold">Payment Term</div>
          <div class="offer-value-column-value">{{ offer.paymentTerm ? paymentTerms[offer.paymentTerm].display : '—' }}</div>
        </div>
      </div>
      <div class="grid-section offer-section-right">
        <div class="offer-value-row">
          <div class="tw-font-bold">Origination Fee</div>
          <div class="offer-value-column-value">{{ offer.originationFee ? offer.originationFee + '%' : '—' }}</div>
        </div>
        <div class="offer-value-row">
          <div class="tw-font-bold">Position</div>
          <div class="offer-value-column-value" *ngIf="offer.position">{{ offer.position ? offer.position : '—' }}</div>
        </div>
        <div class="offer-value-row">
          <div class="tw-font-bold">Contract Dur.</div>
          <div class="offer-value-column-value">{{ offer.term ? offer.term : '—' }} mo.</div>
        </div>
        <div class="offer-value-row">
          <div class="tw-font-bold">Date Received</div>
          <div class="offer-value-column-value" *ngIf="offer.received">{{ offer.received | date:'shortDate' }}</div>
          <div class="offer-value-column-value" *ngIf="!offer.received">—</div>
        </div>
        <div class="offer-value-row">
          <div class="tw-font-bold">Expiration Date</div>
          <div class="offer-value-column-value" *ngIf="offer.expiration">{{ offer.expiration | date:'shortDate' }}</div>
          <div class="offer-value-column-value" *ngIf="!offer.expiration">—</div>
        </div>
        <div class="offer-value-row">
          <div class="tw-font-bold">Type</div>
          <div class="offer-value-column-value">{{ offer.type | titlecase }}</div>
        </div>
        <div class="offer-value-row">
          <div class="tw-font-bold">Net Fund Amount</div>
          <div class="offer-value-column-value" *ngIf="offer.netFundedAmount">{{ offer.netFundedAmount | currency }}</div>
          <div class="offer-value-column-value" *ngIf="!offer.netFundedAmount">—</div>
        </div>
      </div>
    </div>
  </div>

  <div class="grid-section offer-link" *ngIf="offer.url">
    <div class="offer-link-column-key">
      Offer Acceptance URL
      <span
        matTooltip="This link directs a Borrower to the Lender’s portal where they will perform final steps to accept their offer. This is a one-time use link, so do not visit this page!"
        [matTooltipPosition]="'above'"
        class="offer-acceptance-icon">
        <mat-icon color="primary">info_outline</mat-icon>
      </span>
    </div>
    <div
      class="offer-link-column-value"
      (click)="copyUrl(offer.url)"
      matTooltip="Click to copy the offer acceptance link"
      [matTooltipPosition]="'above'">
      {{ offer.url }}
    </div>
  </div>

  <div class="grid-section offer-notes" *ngIf="offer.notes">
    <div class="tw-font-bold">Notes</div>
    <div>{{ offer.notes }}</div>
  </div>

  <div class="grid-section benefits">
    <app-value-props-smart [option]="offer" optionType="offer"></app-value-props-smart>
  </div>

  <!-- OFFER FOOTER -->
  <div class="offer-footer" *ngIf="offer.id && !offer.offerLink && dealStage !== 'inactive' && dealStage !== 'funded'">
    <div class="section-container">
      <div class="grid-section">
          <span class="accept-offer-toggle tw-items-center" *ngIf="dealStage != 'inactive'">
            Offer Accepted?
            <mat-slide-toggle
              data-cy="accept-offer-toggle"
              color="primary"
              class="accept-offer-toggle tw-ml-2"
              [checked]="offer.accepted"
              [disabled]="readOnly || (offer.borrowerDeclined || disableOffer)"
              (change)="acceptedToggleChange($event)">
            </mat-slide-toggle>
          </span>
      </div>
    </div>
  </div>
</mat-expansion-panel>

<ng-template #actionsDropdown>
  <button mat-icon-button
          [matMenuTriggerFor]="offerMoreMenu"
          (click)="$event.stopPropagation();"
          data-cy="option-more-btn"
  >
    <mat-icon
      data-cy="option-more-btn">
      more_vert
    </mat-icon>
  </button>
  <mat-menu #offerMoreMenu="matMenu" class="offer-more-menu">
    <button
      mat-menu-item
      class="offer-more-menu"
      data-cy="send-to-bp-btn"
      [disabled]="disableOffer || !canBePublished"
      matTooltip="Send the terms of this offer to Borrower Portal to be accepted (or declined). Note: Once you send it you'll be unable to edit the details."
      [matTooltipPosition]="'above'"
      (click)="canBePublished && handlePublish()"
      *ngIf="!readOnly"
    >
      Publish to portal
    </button>
    <button
      mat-menu-item
      class="offer-more-menu"
      data-cy="remove-from-bp-btn"
      [disabled]="disableOffer || !canBeRemovedFromPortal"
      (click)="canBeRemovedFromPortal && handleRemoveFromPortal()"
      *ngIf="!readOnly"
    >
      Remove from portal
    </button>
    <button
      mat-menu-item
      class="offer-more-menu"
      data-cy="request-contract-offer-menu-item"
      matTooltip="Creates a contract request from the offer. Only one contract request can be made per deal."
      [disabled]="hasContractRequest"
      (click)="canCreateContractRequest && requestContract()"
      *ngIf="canCreateContractRequest"
    >
      Request Contract
    </button>
    <button
      mat-menu-item
      class="offer-more-menu"
      data-cy="offer-edit-btn"
      (click)="handleEdit()"
      *ngIf="canEditOffer">
      Edit
    </button>
    <button
      mat-menu-item
      class="offer-more-menu"
      data-cy="offer-duplicate-btn"
      (click)="handleDuplicate()"
      *ngIf="canEdit && allowDuplicate">
      Duplicate
    </button>
    <button
      mat-menu-item
      class="offer-more-menu"
      data-cy="offer-decline-btn"
      (click)="handleDecline()"
      *ngIf="canDecline">
      Decline
    </button>
    <button
      mat-menu-item
      class="offer-more-menu"
      data-cy="offer-undecline-btn"
      (click)="handleDecline()"
      *ngIf="canUndecline">
      Un-decline
    </button>
    <button
      mat-menu-item
      class="offer-more-menu"
      data-cy="offer-delete-btn"
      (click)="confirmDelete()"
      *ngIf="canDeleteOffer">
      Delete
    </button>
  </mat-menu>
</ng-template>
